import React from 'react';
import { CalendarCheckIcon, CheckCircle2Icon, DownloadIcon, InfinityIcon, MonitorSmartphoneIcon, PackageCheckIcon, SparklesIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const accessPoints = [{
  icon: DownloadIcon,
  text: 'Descarga inmediata'
}, {
  icon: InfinityIcon,
  text: 'Acceso para siempre'
}, {
  icon: MonitorSmartphoneIcon,
  text: 'Computadora, tablet y celular'
}];
export function HeroSection() {
  return <section className="relative overflow-hidden bg-gradient-to-b from-amber-50 via-orange-50 to-white py-9 sm:py-14 md:py-20" data-id="element-36">
      <div className="pointer-events-none absolute -left-12 top-16 h-36 w-36 rounded-full bg-yellow-200/50 blur-3xl" data-id="element-37" />
      <div className="pointer-events-none absolute -right-12 top-28 h-44 w-44 rounded-full bg-pink-200/50 blur-3xl" data-id="element-38" />

      <div className="container relative mx-auto px-4 md:px-6" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mx-auto max-w-4xl text-center" data-id="element-40">
          <div className="inline-flex items-center gap-2 rounded-full border border-orange-200 bg-white px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.16em] text-orange-700 shadow-sm sm:text-xs" data-id="element-41">
            <SparklesIcon className="h-3.5 w-3.5" data-id="element-42" />
            Recursos para Nivel Inicial
          </div>

          <h1 className="mx-auto mt-4 max-w-[23rem] text-[2.45rem] font-black leading-[0.97] tracking-[-0.045em] text-slate-900 sm:max-w-3xl sm:text-6xl md:text-7xl" data-id="element-43">
            <span className="block text-[0.62em] uppercase tracking-[0.12em] text-slate-700 sm:text-[0.56em]" data-id="element-44">
              Dejá de crear
            </span>
            <span className="mt-1 block text-orange-600" data-id="element-45">planificaciones</span>
            <span className="relative mt-1 inline-block px-2 text-slate-900 sm:px-3" data-id="element-46">
              <span className="absolute inset-x-0 bottom-1 h-[0.38em] -rotate-1 rounded-full bg-yellow-300/80" data-id="element-47" />
              <span className="relative" data-id="element-48">desde cero.</span>
            </span>
          </h1>

          <p className="mx-auto mt-5 max-w-3xl text-[17px] font-semibold leading-snug text-slate-700 sm:text-xl md:text-2xl" data-id="element-49">
            Tené prácticamente todo el año resuelto{' '}
            <span className="font-black text-pink-600" data-id="element-50">
              sin volver a pasar horas planificando,
            </span>{' '}
            buscando ideas en Pinterest o comprando recursos sueltos.
          </p>

          <div className="mx-auto mt-6 max-w-3xl rounded-[1.5rem] border border-orange-100 bg-white/85 p-3 shadow-[0_16px_40px_rgba(194,65,12,0.12)] backdrop-blur-sm sm:p-4" data-id="element-51">
            <div className="grid grid-cols-2 gap-2.5 sm:gap-3" data-id="element-52">
              <div className="relative overflow-hidden rounded-2xl bg-orange-500 p-3 text-left text-white sm:p-4" data-id="element-53">
                <CalendarCheckIcon className="absolute right-3 top-3 h-8 w-8 text-orange-300/70" data-id="element-54" />
                <p className="text-3xl font-black leading-none tracking-tight sm:text-4xl" data-id="element-55">
                  +100
                </p>
                <p className="mt-1 max-w-[10rem] text-xs font-extrabold leading-snug sm:text-sm" data-id="element-56">
                  planificaciones completas listas para usar
                </p>
              </div>
              <div className="relative overflow-hidden rounded-2xl bg-pink-500 p-3 text-left text-white sm:p-4" data-id="element-57">
                <PackageCheckIcon className="absolute right-3 top-3 h-8 w-8 text-pink-200/75" data-id="element-58" />
                <p className="text-3xl font-black leading-none tracking-tight sm:text-4xl" data-id="element-59">
                  +250
                </p>
                <p className="mt-1 max-w-[10rem] text-xs font-extrabold leading-snug sm:text-sm" data-id="element-60">
                  recursos para acompañarte todo el año
                </p>
              </div>
            </div>

            <ul className="mt-3 grid gap-2 text-left sm:grid-cols-3" data-id="element-61">
              {accessPoints.map(({
              icon: Icon,
              text
            }) => <li key={text} className="flex items-center gap-2 rounded-xl bg-amber-50 px-2.5 py-2 text-xs font-bold leading-snug text-slate-700 sm:px-3 sm:text-sm" data-id="element-62">
                  <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-lg bg-white text-orange-600 shadow-sm" data-id="element-63">
                    <Icon className="h-3.5 w-3.5" data-id="element-64" />
                  </span>
                  {text}
                </li>)}
            </ul>
          </div>

          <div className="mt-6 flex justify-center" data-id="element-65">
            <CTAButton href="#pricing" text="Quiero tener el año resuelto" className="w-full max-w-sm bg-orange-500 px-5 py-4 text-base shadow-orange-200 sm:max-w-md sm:text-lg" data-id="element-66" />
          </div>
          <p className="mt-3 flex items-center justify-center gap-1.5 text-xs font-semibold text-slate-500" data-id="element-67">
            <CheckCircle2Icon className="h-4 w-4 text-green-600" data-id="element-68" />
            Una sola compra para planificar con más calma durante todo el año.
          </p>
        </motion.div>
      </div>
    </section>;
}